import React from 'react';
import PropTypes from 'prop-types';

import env from 'pages/MyAccount/utils/env';
import manageMembershipStyles from './ManageMembership.module.css';

const ManageMembershipLink = ({ key, path, title, subtitle, onClickCTA }) => {
  const { hostname } = env;
  return (
    <a
      key={key}
      href={`https://${hostname}${path}`}
      onClick={onClickCTA}
      className={`${manageMembershipStyles.linkContainer}`}
      data-testid={`${title}-link`}
    >
      <div className={`${manageMembershipStyles.linkTitle}`}>{title}</div>
      <div className={`${manageMembershipStyles.linkSubTitle}`}>{subtitle}</div>
    </a>
  );
};

ManageMembershipLink.propTypes = {
  key: PropTypes.string,
  path: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onClickCTA: PropTypes.func,
};

ManageMembershipLink.defaultProps = {
  key: '',
  path: '',
  title: '',
  subtitle: '',
  onClickCTA: () => true,
};

export default ManageMembershipLink;
